
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCodeGoogle as ObiCodeGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-code-google.js';
 
 
 

 
 export const ObiCodeGoogle = createComponent({
   react: React,
   tagName: 'obi-code-google',
   elementClass: ObiCodeGoogleElement,
   events: {
     
   }
  });
 
 